<template>
  <LLPage class="ChatSavedPage">
    <template #breadcrumbs>
      <LLBreadCrumbs :crumbs="crumbs" />
    </template>
    <template #content>
      <LLLoader v-if="isFetching"></LLLoader>
      <LLLoaderError v-else-if="error">
        {{ error }}
      </LLLoaderError>
      <div v-else class="ChatSavedPage__content">
        <MemberProfileFlow v-if="chat" :chat="chat" />
        <SavedPostsModule :chat="chat" :threads="threads" />
      </div>
    </template>
  </LLPage>
</template>

<script>
import LLPage from '@/components/layout/LLPage'
import LLLoader from '@/components/common/LLLoader'
import LLLoaderError from '@/components/common/LLLoaderError'
import LLBreadCrumbs from '@/components/common/ui-components/LLBreadCrumbs'
import { ForumChatModel } from '@/models/forum/forumChat'
import SavedPostsModule from '@/components/pages/saved-posts/SavedPostsModule.vue'
import MemberProfileFlow from '@/components/pages/forum/member-profile/MemberProfileFlow.vue'

export default {
  name: 'ChatSavedPage',
  components: {
    SavedPostsModule,
    MemberProfileFlow,
    LLBreadCrumbs,
    LLLoaderError,
    LLLoader,
    LLPage
  },
  data() {
    return {
      chat: null,
      isFetching: false,
      error: null,
      threads: [],
      redirectedFromDestination: false
    }
  },
  computed: {
    chatIdParam() {
      return +this.$route.params.chatId
    },
    crumbs() {
      return [
        { name: this.$t('main_home_label'), path: '/' },
        {
          name: this.$t('forum.chat_list_page.title', { teamName: this.selectedTeam?.name }),
          path: '/chats'
        },
        {
          name: this.chat?.name || this.$t('forum.saved_page.title'),
          path: `/chats/${this.chatIdParam}`
        },
        {
          name: this.$t('forum.saved_page.title')
        }
      ]
    }
  },
  created() {
    if (+this.$store.state?.completeRegistration?.chatId === this.chatIdParam) {
      this.redirectedFromDestination = true
    }
    this.$store.commit('completeRegistration/RESET_DESTINATION')
    this.fetch()
  },
  methods: {
    async fetch() {
      this.error = null
      this.isFetching = true
      try {
        const { chat: serverChat } = await this.$api.forum.chats.get({ chatId: this.chatIdParam })
        const chat = ForumChatModel.parseFromApi({ chat: serverChat })
        this.chat = chat

        // Fetch threads for filter
        try {
          const { threads } = await this.$api.forum.threads.getAll({
            chatId: this.chatIdParam,
            perPage: 200
          })
          this.threads = threads || []
        } catch (e) {
          // Threads filter is not critical
        }
      } catch (e) {
        if (e.response?.status === 404) {
          if (this.redirectedFromDestination) {
            this.$router.replace('/chats')
          } else {
            this.$router.replace('/404')
          }
        } else {
          this.error = this.$getErrorMessage(e)
        }
      }
      this.isFetching = false
    }
  }
}
</script>
